import { createSlice } from '@reduxjs/toolkit';
import { getHotelImagesBySize } from './transform';

import type { SetImagesAction, HotelImagesState } from './types';

const initialState: HotelImagesState = {};

const hotelImagesSlice = createSlice({
  name: 'hotelImages',
  initialState,
  reducers: {
    setImages: (state, action: SetImagesAction) => {
      const images = getHotelImagesBySize(action.payload);
      if (images) {
        Object.assign(state, images);
      }
    },
  },
});

export const { setImages } = hotelImagesSlice.actions;
export const { name } = hotelImagesSlice;
export default hotelImagesSlice.reducer;
